import React, { useEffect, useState } from 'react';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import { DetailItem } from 'app/shared/info-section/item';
import { toDateString } from 'app/shared/utils/date';
import { useMobilePushMessageService } from 'hooks/messaging/mobile/message';
import { useAudienceService } from 'hooks/users/audience';

export const WebPushBasicInfo = ({ id }) => {
  const { fetchAudiences } = useAudienceService();
  const { fetchMessages } = useMobilePushMessageService();

  const [audiences, setAudiences] = useState([]);
  const [message_data, setMessageData] = useState({});

  useEffect(() => {
    if (!id) return;
    fetchMessages({ query_string: `id=${id}` }).then(({ messages: [message] }) => {
      if (!message) return;
      setMessageData(message);
      if (message.type === 'campaign') {
        fetchAudiences({ query_string: `id=${message.audiences.join('')}` }).then(
          ({ audiences: auds }) => {
            setAudiences(auds);
          }
        );
      }
    });
  }, [id]);

  return (
    <>
      <BasicInfoSection title="Basic Details">
        <DetailItem title="title">{message_data.title}</DetailItem>
        <DetailItem title="sender ID">{message_data.sender_id}</DetailItem>
        <DetailItem title="Message">{message_data.message}</DetailItem>
        <DetailItem title="Type">{message_data.type}</DetailItem>
        {message_data.type === 'campaign' && (
          <>
            <DetailItem title="status">{message_data.status}</DetailItem>
            <DetailItem title="Audiences">
              {audiences.map((aud) => (
                <div key={aud.id}>{aud.name}</div>
              ))}
            </DetailItem>
            <DetailItem title="schedule">{toDateString(message_data.schedule.date)}</DetailItem>
          </>
        )}
      </BasicInfoSection>
    </>
  );
};
